// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"2371aaa4","172":"652dd1a7","983":"2ba6b832"}[chunkId] + ".chunk.css";
};